import { render, staticRenderFns } from "./Scrap.vue?vue&type=template&id=602dbf10&scoped=true"
import script from "./Scrap.vue?vue&type=script&lang=js"
export * from "./Scrap.vue?vue&type=script&lang=js"
import style0 from "./Scrap.vue?vue&type=style&index=0&id=602dbf10&prod&lang=scss"
import style1 from "./Scrap.vue?vue&type=style&index=1&id=602dbf10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_cache-loader@4.1.0_webpack@4.47.0__css-load_857a25aa4406afef410ce4b662efafed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602dbf10",
  null
  
)

export default component.exports